import React from "react";
import { connect, useDispatch } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { Dropdown, Input } from "semantic-ui-react";
import {
  getFilteredCreator,
  getFilteredDate,
  getFilteredSport,
  getFilteredSuperCreator,
  getFilteredSuperDate,
  getFilteredSuperSport,
} from "../../store/actions/athleteActions";
import "./Events.css";

const EventsFilter = (props) => {
  // const debounceLog = debounce((query) => {
  //   props.searchQuery(query.trim().toLowerCase());
  // }, 300);
  const dispatch = useDispatch();
  const handleFilterChange = (not, data) => {
    props.onChange();
    switch (data.name) {
      case "filteredSport":
        dispatch(getFilteredSport(data.value));
        break;
      case "filteredSuperSport":
        dispatch(getFilteredSuperSport(data.value));
        break;

      case "filteredSuperCreator":
        dispatch(getFilteredSuperCreator(data.value));
        break;
      case "filteredCreator":
        dispatch(getFilteredCreator(data.value));
        break;

      case "filteredSuperDate":
        dispatch(getFilteredSuperDate(data.value));
        break;
      case "filteredDate":
        dispatch(getFilteredDate(data.value));
        break;

      default: {
      }
    }
  };

  return (
    <>
      <div className="AthleteSearchBanner main-filter-event">
        <h1>Events</h1>
        <div className="AthleteSearchFilterContainer">
          <Input
            icon="search"
            placeholder="Search Events..."
            name="filteredSearch"
            onChange={(e) =>
              props.searchQuery(e.target.value.trim().toLowerCase())
            }
            autoComplete="off"
          />
          <div className="AthleteSearchFilter">
            <Dropdown
              onChange={handleFilterChange}
              options={props.sports}
              placeholder={"Sport"}
              defaultValue={
                !props.superAdmin
                  ? props.sport
                    ? props.sport
                    : null
                  : props.superSport
                  ? props.superSport
                  : null
              }
              name={!props.superAdmin ? "filteredSport" : "filteredSuperSport"}
              selection
              fluid
              clearable
            />
            <Dropdown
              onChange={handleFilterChange}
              options={props.dates}
              placeholder={"Date"}
              defaultValue={
                !props.superAdmin
                  ? props.date
                    ? props.date
                    : null
                  : props.superDate
                  ? props.superDate
                  : null
              }
              name={!props.superAdmin ? "filteredDate" : "filteredSuperDate"}
              selection
              fluid
              clearable
            />
            <Dropdown
              onChange={handleFilterChange}
              options={props.creators}
              placeholder={"Attenders"}
              defaultValue={
                !props.superAdmin
                  ? props.creator
                    ? props.creator
                    : null
                  : props.superCreator
                  ? props.superCreator
                  : null
              }
              name={
                !props.superAdmin ? "filteredCreator" : "filteredSuperCreator"
              }
              selection
              search
              fluid
              clearable
            />
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  let events = [];
  let creator = [];
  if (
    state.firestore.data.events &&
    state.firestore.data.athletes &&
    state.firestore.data.advocates
  ) {
    const keys = Object.keys(state.firestore.data.events);
    const rawEvents = keys.map((key) => {
      if (state.firestore.data.events[key]) {
        let event = state.firestore.data.events[key];
        if (event) {
          let attenders = event.eventAttenders;
          attenders = attenders.map((visitor, i) => {
            const person = {};
            if (visitor in state.firestore.data.athletes) {
              creator.push({
                key: i,
                text:
                  state.firestore.data.athletes[visitor].firstName +
                  " " +
                  state.firestore.data.athletes[visitor].lastName,
                value: visitor,
              });
              person.name =
                state.firestore.data.athletes[visitor].firstName +
                " " +
                state.firestore.data.athletes[visitor].lastName;
              person.image = state.firestore.data.athletes[visitor].thumbnail;
              person.id = visitor;
              person.customUrl =
                state.firestore.data.athletes[visitor].customUrl;
            } else if (visitor in state.firestore.data.advocates) {
              creator.push({
                key: i,
                text: state.firestore.data.advocates[visitor].name,
                value: visitor,
              });
              person.name = state.firestore.data.advocates[visitor].name;
              person.image =
                state.firestore.data.advocates[visitor].thumbnailUrl;
              person.id = visitor;
              person.customUrl =
                state.firestore.data.advocates[visitor].customUrl;
            }
            return person;
          });
          return { ...event, attenders };
        }
      }
    });
    events = rawEvents.filter((event) => event);
    events = events.sort(
      (date1, date2) => date2.eventStartDate - date1.eventStartDate
    );
  }
  const dates = events.map((event, i) => {
    return {
      key: i,
      text: event.eventStartDate.toDate().toDateString(),
      value: event.eventStartDate,
    };
  });
  const sports = events.map((event, i) => {
    return {
      key: i,
      text: event.eventSport,
      value: event.eventSport,
    };
  });
  const filteredSport = sports.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t.text === value.text)
  );
  const filteredDates = dates.filter(
    (value, index, self) =>
      index === self.findIndex((t) => t.text === value.text)
  );
  const filteredCreators = creator.filter(
    (value, index, self) =>
      index ===
      self.findIndex((t) => t.text === value.text && t.value === value.value)
  );
  filteredCreators.forEach((creator, i) => {
    creator.key = i;
  });
  return {
    creators: filteredCreators,
    dates: filteredDates,
    sports: filteredSport,
    sport: state.athlete.sport,
    superSport: state.athlete.superSport,
    date: state.athlete.date,
    superDate: state.athlete.superDate,
    creator: state.athlete.creator,
    superCreator: state.athlete.superCreator,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "events",
    },
    {
      collection: "adminAthletes",
      storeAs: "athletes",
    },
    {
      collection: "advocates",
    },
  ])
)(EventsFilter);
